$(document).ready(function () {
    const $table = $('#stock-balances-table');
    if (!$table.length) return;

    const dt = window.initStockBalanceTable($table, true);

    $table.on('xhr.dt', function (_, __, json) {
        if (!json || !json.summary) return;
        const totals = json.summary.totals || {};
        const formatMoney = function (kopecks) { return $.fn.dataTable.render.number(' ', ',', 2).display((parseFloat(kopecks) || 0) / 100); };
        const requiresValuation = (parseInt(totals.unknown_cost_quantity, 10) || 0) + (parseInt(totals.review_quantity, 10) || 0);
        $('.panel-title:contains("Всего, шт.")').closest('.panel').find('h3').text(parseInt(totals.quantity, 10) || 0);
        $('.panel-title:contains("Заморожено, подтвержденная стоимость")').closest('.panel').find('h3').text(formatMoney(totals.frozen_confirmed_kopecks));
        $('.panel-title:contains("Стоимость неизвестна")').closest('.panel').find('h3').text(parseInt(totals.unknown_cost_quantity, 10) || 0);
        $('.panel-title:contains("Требует решения")').closest('.panel').find('h3').text(requiresValuation);
    });

    function updatePrintUrl() {
        const $printBtn = $('#stock-balances-print-btn');
        if (!$printBtn.length) return;
        const params = new URLSearchParams();
        $('#stock-balances-filters').serializeArray().forEach(function (item) {
            if (item.value !== '') params.append(item.name, item.value);
        });
        if (dt.search()) params.set('search', dt.search());
        const baseUrl = $printBtn.attr('href').split('?')[0];
        const queryString = params.toString();
        $printBtn.attr('href', baseUrl + (queryString ? '?' + queryString : ''));
    }

    $('#stock-balances-print-btn').on('click', updatePrintUrl);
    $('#stock-balances-filters').on('changed.bs.select change', 'select', function () {
        dt.page('first').draw('page');
        updatePrintUrl();
    }).on('submit', function (e) {
        e.preventDefault();
        dt.page('first').draw('page');
        updatePrintUrl();
    }).on('click', '.js-table-reset', function () {
        const form = $('#stock-balances-filters');
        form[0].reset();
        form.find('[name="property_scope"]').remove();
        form.find('.selectpicker').selectpicker('refresh');
        dt.search('').order([1, 'asc']).page('first').draw();
        updatePrintUrl();
    });
});
